<div class="sub-header">
  <div class="sub-header-row px-1 py-2">
    <div class="row">
      <div class="col">
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="col">
        <div class="float-end fs-4 text-primary">
          {{ this.periodLabel }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (this.salesTeamListItems$ | async; as salesTeams) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 235px;"
              bindValue="id"
              bindLabel="name"
              [items]="salesTeams"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="salesTeamIds"
              (ngModelChange)="onSalesTeamIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }} ({{items[0].count}})
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length, p2: (items | totalCountPipe)}">DASHBOARD_LBL_SALESTEAM_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span class="ps-1" title="{{ item.name }} ({{item.count}})">{{ item.name }} ({{item.count}})</span>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (this.salesPersonListItems$ | async; as salesPersons) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 265px;"
              bindValue="id"
              bindLabel="name"
              [items]="salesPersons"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="salesPersonIds"
              (ngModelChange)="onSalesPersonIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }} ({{items[0].count}})
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length, p2: (items | totalCountPipe)}">DASHBOARD_LBL_SALESPERSON_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span class="ps-1" title="{{ item.name }} ({{item.count}})">{{ item.name }} ({{item.count}})</span>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (this.sourcesListItem$ | async; as sources) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 235px;"
              bindValue="id"
              bindLabel="name"
              [items]="sources"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="sourceIds"
              (ngModelChange)="onSourceIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }} ({{items[0].count}})
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length, p2: (items | totalCountPipe)}">DASHBOARD_LBL_SOURCE_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span class="ps-1" [class.text-muted]="item.disabled" [class.text-decoration-line-through]="item.disabled" title="{{ item.name }} ({{item.count}})">{{ item.name }} ({{item.count}})</span>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (this.mediumsListItem$ | async; as mediums) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 240px;"
              bindValue="id"
              bindLabel="name"
              [items]="mediums"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="mediumIds"
              (ngModelChange)="onMediumIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }} ({{items[0].count}})
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length, p2: (items | totalCountPipe)}">DASHBOARD_LBL_MEDIUM_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span class="ps-1" [class.text-muted]="item.disabled" [class.text-decoration-line-through]="item.disabled" title="{{ item.name }} ({{item.count}})">{{ item.name }} ({{item.count}})</span>
              </ng-template>
            </ng-select>
          </div>
        }
        @if (this.campaignsListItem$ | async; as campaigns) {
          <div
            class="d-inline-block mx-2"
            >
            <ng-select
              class="form-control form-control-sm"
              style="width: 260px;"
              bindValue="id"
              bindLabel="name"
              [items]="campaigns"
              [multiple]="true"
              [selectableGroup]="false"
              [closeOnSelect]="false"
              [clearable]="false"
              [(ngModel)]="campaignIds"
              (ngModelChange)="onCampaignIdsChange()"
              >
              <ng-template ng-multi-label-tmp let-items="items">
                @if (items.length === 1) {
                  {{ items[0].name }} ({{items[0].count}})
                }
                @if (items.length > 1) {
                  <span translate [translateParams]="{ p1: items.length, p2: (items | totalCountPipe)}">DASHBOARD_LBL_CAMPAIGN_SELECTED</span>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"/><span class="ps-1" [class.text-muted]="item.disabled" [class.text-decoration-line-through]="item.disabled" title="{{ item.name }} ({{item.count}})">{{ item.name }} ({{item.count}})</span>
              </ng-template>
            </ng-select>
          </div>
        }
      </div>
      <div class="col-auto">
        @if (this.periods$ | async; as periods) {
          <div
            class="d-inline-block float-end mx-2"
            >
            <!--            (change)="onPeriodChange($event)"-->
            <select
              class="form-control form-control-sm form-select"
              style="width: 200px;"
              [ngModel]="this.period"
              (ngModelChange)="onPeriodChange($event)"
              >
              <option disabled style="background-color: lightgray" translate>
                DASHBOARD_LBL_SELECT_OPTION_GROUP_STANDARD_PERIOD
              </option>
              @for (period of periods; track period) {
                @if (period.group == 'Périodes standards') {
                  <option
                    value="{{ period.value }}"
                    >
                    {{ period.label }}
                  </option>
                }
              }
              <option disabled style="background-color: lightgray" translate>
                DASHBOARD_LBL_SELECT_OPTION_GROUP_RECENTLY
              </option>
              @for (period of periods; track period) {
                @if (period.group == 'Récemment') {
                  <option
                    value="{{ period.value }}"
                    >
                    {{ period.label }}
                  </option>
                }
              }
            </select>
          </div>
        }
      </div>
    </div>
  </div>
</div>
